import { Component } from '@angular/core';

@Component({
  templateUrl: './welcome-university.component.html'
})
export class WelcomeUniveristyComponent {
  videoId = '817578538';
}
